import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useQueryParam, StringParam } from "use-query-params"
import { Link } from 'gatsby'

import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import Layout from '../../layouts'
import LargeHero from "../../components/elements/largeHero"
import { SizedText, Body } from "../../components/elements/typography"
import ReviewSection from "../../components/sections/reviewSection"
import ExternalLink from '../../components/elements/externalLink'
import SEO from "../../components/elements/seo"

import Grid from '../../components/elements/grid'


const ArticleBlock = ({ key, url, title, description, img}) => {

  const image = getImage(img)

  return (
    <Link key={key} to={`/${url}`} css={{
      backgroundColor: `#fff`,
      boxShadow: `0 1px 2px rgba(0,0,0,0.15)`,
      textDecoration: `none`,
      transition: `margin 0.5s, background-color 0.5s`,
      margin: `0.5rem`,
      '&:hover': {
        margin: `0`,
        backgroundColor: `#fff`
      },
      '.img': {
        boxShadow: `0 0 200px rgba(0,0,0,0.9) inset`,
      }
    }}>
      <div css={{
        width: `100%`,
      }}> 
          <GatsbyImage image={image} layout="fullWidth" aspectRatio={16 / 9} alt="test" /> 
      </div>
      <div css={{padding: `1rem 1.5rem 2rem 1.5rem`}}>
        <h2 css={{color: `#182852`, marginBottom: `0`}}>{title}</h2> 
        <Body>{description}</Body>
      </div>
    </Link>
  )
}

const TipBlockContent = ({title, description, children,}) => {
  return (
    <>
      <div css={{
        width: `100%`,
      }}> 
          {children}
      </div>
      <div css={{padding: `1rem 1.5rem 2rem 1.5rem`}}>
        <h2 css={{color: `#182852`, marginBottom: `0`}}>{title}</h2> 
        <Body>{description}</Body>
      </div>
    </>
  )
}

const TipBlock = ({ url, title, description, children, external }) => {

  const blockStyles = {
    backgroundColor: `#fff`,
    boxShadow: `0 1px 2px rgba(0,0,0,0.15)`,
    textDecoration: `none`,
    transition: `margin 0.5s, background-color 0.5s`,
    margin: `0.5rem`,
    '&:hover': {
      margin: `0`,
      backgroundColor: `#fff`
    },
    '.img': {
      boxShadow: `0 0 200px rgba(0,0,0,0.9) inset`,
    }
  }


  return (

    <>
      {external
        ? <ExternalLink to={url} styles={{...blockStyles}}><TipBlockContent title={title} description={description}>{children}</TipBlockContent></ExternalLink>
        : <Link to={url} css={{...blockStyles}}><TipBlockContent title={title} description={description}>{children}</TipBlockContent></Link>
      }
    </>
  )
}




const ResourcesIndexPage = ({ data }) => {

  const [tag, setTag] = useQueryParam("tag", StringParam)

  const blogPosts = data.allMdx.nodes.map(i => (
    <ArticleBlock key={i.id} url={i.slug} title={i.frontmatter.title} description={i.frontmatter.description} img={i.frontmatter.featuredImage}/>
  ))

  const formsList = data.allFormsFormsYaml.nodes.map(i => (
    <li key={i.yamlId}><Link to={`/resources/forms/${i.name.replaceAll(' ', '-').toLowerCase()}`}>{i.name}</Link></li>
  ))

  return (
    <Layout isSubMenuOpen={false} openAccountLink={false}>

      <SEO
        title="TCB Resource Center - Financial Literacy, Forms, How-Tos and More"
        description="Take control of your finances, with help from the TCB resource center.  Learn about financial wellness, TCB product tips, small business resources, forms and more.  "
        location="/"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

      <LargeHero.Container
        background={{
          backgroundColor: `#ffaa00`,
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.22'%3E%3Cpath fill='%23ffb100' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%23ffb800' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%23ffbe00' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23ffc500' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23ffcc00' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23ffd914' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23ffe529' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23ffef3d' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23fff852' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23ffff66' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundAttachment: `fixed`,
backgroundSize: `cover`,
        }}
        styles={{
          paddingBottom: `0`,
          '@media (min-width: 680px)': {
            '.heroContent': { width: `calc(60% - 1rem)`},
            '.heroImage': { width: `calc(40% - 1rem)`},
          },

          '@media (min-width: 1080px)': {
            '.heroContent': { width: `calc(60% - 2.5rem) !important`},
            '.heroImage': { width: `calc(40% - 2.5rem) !important`},
          }
      }}>
        <LargeHero.Content>
          <LargeHero.Eyebrow text="Resources" />
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`, 'span': {display: `block`, lineHeight: `1`, padding: `0.25rem 0 4rem 0`}}}>
            <SizedText as="span" smallSize="2.887" largeSize="4.624">Take Control of Your Finances</SizedText>
          </h1>
        </LargeHero.Content>
        <LargeHero.Image>
          <StaticImage src="../../images/people/happy-family-1.png" alt="" css={{
            display: `block`,
            '@media (min-width: 680px)': { display: `none` },
            '@media (min-width: 1080px)': { display: `block` }
          }}/>
          <StaticImage src="../../images/people/happy-family-1_tablet.png" alt="" css={{
            display: `none`,
            '@media (min-width: 680px)': { display: `block` },
            '@media (min-width: 1080px)': { display: `none` }
          }}/>
        </LargeHero.Image>
      </LargeHero.Container>

      {/* --- Wellness Articles --- */}
      <Grid.FullWidthSection css={{ margin: `6rem 0`}}>
        <Grid.Block start='2' span='12'>
          <h1 css={{fontFamily: `Proxima-nova`, textAlign: `center`, marginBottom: `4rem`}}>
            <SizedText as="span" smallSize="2.027" largeSize="3.653">Learn About Financial Wellness</SizedText>
          </h1>
          <div css={{
            display: `grid`,
            gridRowGap: `2rem`,
            '@media (min-width: 680px)': { 
              gridTemplateColumns: `1fr 1fr`,
              padding: `0 2rem`,
              gridGap: `1.5rem`
            },
            '@media (min-width: 1000px)': { 
              gridTemplateColumns: `1fr 1fr 1fr`,
            },
            '@media (min-width: 1200px)': { 
              gridTemplateColumns: `1fr 1fr 1fr`,
              padding: `0 2rem`,
              gridGap: `3rem`
            }
          }}>
            {blogPosts}
          </div>
          <div css={{textAlign: `center`, marginTop: `4rem`}}>
          <Link 
              to="/resources/wellness/articles/"
              css={{
                padding: `0.75rem 2rem`,
                backgroundColor: `#2ecc71`, 
                borderRadius: `0.5rem`,
                color: `#fff !important`,
                textDecoration: `none`,
                border: `1px solid #27ae60`
              }}
            >
              <span>View More Articles</span>
            </Link>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- Product FAQs --- */}
      {/* <Grid.FullWidthSection styles={{
        overflow: `hidden`,
        backgroundColor: `#fff`, 
        boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,  
        alignItems: `center`,
        padding: `6rem 0`,
        boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        overflowX: `hidden`,
      }}>
        <Grid.Block start='2' span='12'>
          <h1 css={{fontFamily: `Proxima-nova`, textAlign: `center`, marginBottom: `4rem`}}>
            <SizedText as="span" smallSize="2.027" largeSize="3.653">Get The Most From Our Products</SizedText>
          </h1>
          <div css={{
            display: `grid`,
            gridRowGap: `2rem`,
            '@media (min-width: 680px)': { 
              gridTemplateColumns: `1fr 1fr`,
              padding: `0 2rem`,
              gridGap: `1.5rem`
            },
            '@media (min-width: 1200px)': { 
              gridTemplateColumns: `1fr 1fr 1fr 1fr`,
            },
            '@media (min-width: 1800px)': { 
              gridGap: `3rem`
            },
          }}>
            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Activate Your Card Online"
              description="Activating your card is easy with the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/product-tips/digital-banking-tips.jpg" />
            </TipBlock>

            <TipBlock 
              url="/resources/product-tips/digital-banking/pin-change"
              title="Change Your PIN Online"
              description="Learn how to change your debit card PIN right from the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/product-tips/pin-change-banner.jpeg" />
            </TipBlock>

            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Increase Your Spending Limit"
              description=" Learn how to temporarily increase your debit spening limit right from the App. "
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/product-tips/limit-increase.jpeg" />
            </TipBlock>
            
            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Set a Travel Alert"
              description=" Learn how to set a travel notification from the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/product-tips/travel-alert.jpeg" />
            </TipBlock>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>*/}

      {/* --- FORMS AND CALCULATORS --- */}
      {/*<Grid.FullWidthSection css={{ padding: `6rem 0`}}>

        <Grid.Block start={['2', '2', '2', '2', '2', '2']} span={['12', '12', '12', '12', '8']}>
          <h1 css={{fontFamily: `Proxima-nova`, marginBottom: `4rem`, textAlign: `center`, '@media (min-width: 1024px)': { textAlign: `left`}}}>
            <SizedText as="span" smallSize="2.027" largeSize="3.653">Calculators</SizedText>
          </h1>
          <div css={{
            display: `grid`,
            gridRowGap: `2`,
            '@media (min-width: 680px)': { 
              gridTemplateColumns: `1fr 1fr`,
              gridGap: `1.5rem`
            },
            '@media (min-width: 1300px)': { 
              gridTemplateColumns: `1fr 1fr 1fr 1fr`,
            }
          }}>
            

            <TipBlock 
              url="/resources/calculators/budget-calculator"
              title="Budget Calculator"
              description="Get help making a personalized budget."
            >
              <StaticImage aspectRatio={4 / 3}
                alt=""
                src="../../images/resources/calculators/budget-calculator.jpeg" />
            </TipBlock>

            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Mortgage Calculator"
              description="Get help calculating motrgage affodability."
            >
              <StaticImage aspectRatio={4 / 3}
                alt=""
                src="../../images/resources/calculators/mortgage-calculator.jpeg" />
            </TipBlock>

            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Credit Payoff"
              description="How long will it take to pay off a credit card?"
            >
              <StaticImage aspectRatio={4 / 3}
                alt=""
                src="../../images/resources/calculators/credit-card-calculator.jpeg" />
            </TipBlock>

            <TipBlock 
              url="/resources/product-tips/digital-banking/card-activation"
              title="Savings Calculator"
              description="See how your money will grow with interest."
            >
              <StaticImage aspectRatio={4 / 3}
                alt=""
                src="../../images/resources/calculators/savings-calculator.jpeg" />
            </TipBlock>

          </div>
        </Grid.Block>
        <Grid.Block start={['2', '2', '2', '2', '10']} span={['12', '12', '12', '12', '4']} css={{padding: `6rem 0 0 4rem`, '@media (min-width: 1024px)': { paddingTop: `0`, borderLeft: `1px solid gray`,}}}>
          <h1 css={{fontFamily: `Proxima-nova`, marginBottom: `4rem`,textAlign: `center`, '@media (min-width: 1024px)': { textAlign: `left`}}}>
            <SizedText as="span" smallSize="2.027" largeSize="3.653">Forms</SizedText>
          </h1>
          <div>
            <ul>
              {formsList}
              <li><Link to={`/resources/forms/`}>View All Forms</Link></li>
            </ul>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>*/}

      {/* --- Small Business --- */}
      <Grid.FullWidthSection styles={{
        overflow: `hidden`,
        backgroundColor: `#fff`, 
        boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='250' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/svg%3E")`,  
        alignItems: `center`,
        padding: `6rem 0`,
        boxShadow: `1px 7px 21px -15px rgba(0,0,0,0.75), 1px -7px 21px -15px rgba(0,0,0,0.75)`,
        overflowX: `hidden`,
      }}>
        <Grid.Block start='2' span='12'>
          <h1 css={{fontFamily: `Proxima-nova`, textAlign: `center`, marginBottom: `4rem`}}>
            <SizedText as="span" smallSize="2.027" largeSize="3.653">Small Business Resources</SizedText>
          </h1>
          <div css={{
            display: `grid`,
            gridRowGap: `2rem`,
            '@media (min-width: 680px)': { 
              gridTemplateColumns: `1fr 1fr`,
              padding: `0 2rem`,
              gridGap: `1.5rem`
            },
            '@media (min-width: 1200px)': { 
              gridTemplateColumns: `1fr 1fr 1fr 1fr`,
            },
            '@media (min-width: 1800px)': { 
              gridGap: `3rem`
            },
          }}>
            <TipBlock 
              url="https://www.georgiasbdc.org/"
              external={true}
              title="UGA Small Business Development Center"
              description="Activating your card is easy with the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/small-business/uga-sbdc.png" />
            </TipBlock>

            <TipBlock 
              url="https://www.georgia.org/"
              external={true}
              title="Georgia Department of Economic Development"
              description="Learn how to change your debit card PIN right from the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/small-business/ga-development.png" />
            </TipBlock>

            <TipBlock 
              url="https://www.score.org/us-small-business-administration-sba"
              external={true}
              title="US Small Business Administration SCORE"
              description=" Learn how to temporarily increase your debit spening limit right from the App. "
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/small-business/sba-score.png" />
            </TipBlock>
            
            <TipBlock 
              url="https://www.rhbcchamber.org/"
              external={true}
              title="Richmond Hill Chamber of Commerce"
              description=" Learn how to set a travel notification from the TCB Digital Banking App."
            >
              <StaticImage aspectRatio={16 / 9}
                alt=""
                src="../../images/resources/small-business/rhbccc.png" />
            </TipBlock>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>

      <ReviewSection />

    </Layout>
  )
}

export const pageQuery = graphql`
  query FeaturedBlogPostQuery {
    allMdx(filter: {}, limit: 3) {
      nodes {
        id
        slug
        frontmatter {
          title
          description
          featuredImage {
            childImageSharp {
              gatsbyImageData(
                width: 1920
                placeholder: BLURRED
                formats: [AUTO, WEBP]  
              )
            }
          }
        }
        
      }
    }
    allFormsFormsYaml(limit: 9) {
      nodes {
        yamlId
        name
      }
    }
  }
`

export default ResourcesIndexPage

